import { AccordionSectionVariantType } from '../../../../../../components/accordionSection/types/accordionSectionVariantType';
import { commonStyles } from '../commonStyles';
export const getFullWidthStyles = (FOUNDATIONS, FONT, SHADOWS) => {
    return {
        [AccordionSectionVariantType.FULL_WIDTH]: {
            ...commonStyles(FOUNDATIONS, FONT, SHADOWS),
            rootContainer: {
                ...commonStyles(FOUNDATIONS, FONT, SHADOWS).rootContainer,
                background_color: FOUNDATIONS.color_comp_containers_bg,
            },
        },
    };
};
//# sourceMappingURL=fullWidth.js.map